import { FileText, GitBranch, Globe, Workflow } from 'lucide-react';
import type { CustomNodeProps, DataSchema } from '../../types/nodes';
import { ApiCallConfig } from './ApiCallConfig';
import { BaseNode } from './BaseNode';
import { ConditionConfig } from './ConditionConfig';
import { PdfConfig } from './PdfConfig';
import { TransformConfig } from './TransformConfig';

const apiOutputSchema: Record<string, DataSchema> = {
	response: {
		type: 'object',
		description: 'The API response data',
		properties: {
			data: {
				type: 'object',
				description: 'Response body data',
			},
			status: {
				type: 'number',
				description: 'HTTP status code',
			},
			headers: {
				type: 'object',
				description: 'Response headers',
			},
		},
	},
};

const conditionOutputSchema: Record<string, DataSchema> = {
	result: {
		type: 'boolean',
		description: 'The result of the condition evaluation',
	},
	value: {
		type: 'object',
		description: 'The value being evaluated',
	},
};

const pdfOutputSchema: Record<string, DataSchema> = {
	url: {
		type: 'string',
		description: 'PDF access URL (signed for private, direct for public)',
	},
	s3Key: {
		type: 'string',
		description: 'S3 object key',
	},
	fileName: {
		type: 'string',
		description: 'Generated filename',
	},
	size: {
		type: 'number',
		description: 'File size in bytes',
	},
	access: {
		type: 'string',
		description: 'Access level (private or public)',
	},
	generatedAt: {
		type: 'string',
		description: 'ISO timestamp of generation',
	},
};

export function ApiCallNode(props: CustomNodeProps) {
	if (props.data.category !== 'processing') return null;

	const nodeData = {
		...props.data,
		outputs: apiOutputSchema,
	};

	return (
		<BaseNode
			{...props}
			data={nodeData}
			icon={Globe}
			configComponent={ApiCallConfig as any} // TODO: Fix type properly in BaseNode
		/>
	);
}

export function TransformNode(props: CustomNodeProps) {
	if (props.data.category !== 'processing') return null;

	// Define transform node output schema based on its mappings
	const outputSchema: Record<string, DataSchema> = {
		result: {
			type: 'object',
			description: 'Transformed data',
		},
	};

	const nodeData = {
		...props.data,
		outputs: outputSchema,
	};

	return (
		<BaseNode
			{...props}
			data={nodeData}
			icon={Workflow}
			configComponent={TransformConfig as any} // TODO: Fix type properly in BaseNode
		/>
	);
}

export function ConditionNode(props: CustomNodeProps) {
	if (props.data.category !== 'processing') return null;

	const nodeData = {
		...props.data,
		outputs: conditionOutputSchema,
	};

	return (
		<BaseNode
			{...props}
			data={nodeData}
			icon={GitBranch}
			configComponent={ConditionConfig as any} // TODO: Fix type properly in BaseNode
		/>
	);
}

export function PdfNode(props: CustomNodeProps) {
	if (props.data.category !== 'processing') return null;

	const nodeData = {
		...props.data,
		outputs: pdfOutputSchema,
	};

	return (
		<BaseNode
			{...props}
			data={nodeData}
			icon={FileText}
			configComponent={PdfConfig as any} // TODO: Fix type properly in BaseNode
		/>
	);
}
